import { render, staticRenderFns } from "./SepaAddSpecifications.vue?vue&type=template&id=2530f27a&scoped=true&"
import script from "./SepaAddSpecifications.vue?vue&type=script&lang=js&"
export * from "./SepaAddSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./SepaAddSpecifications.vue?vue&type=style&index=0&id=2530f27a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530f27a",
  null
  
)

export default component.exports